import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { LotteryOpenService } from './../../services/lotteryopen.service';
import { LotteryOpenModel } from './../../models/lotteryopen.model';
import { OpenList } from './list/openlist';
import { AlertService } from './../../providers/alert.service';
import { LoaddingService } from './../../providers/loadding.service';
import { AuthService } from './../../providers/auth.service';
import { StorageService } from '../../providers/storage.service';
import { BrickTrendPage } from './brick-trend/brick-trend';
import { LotteryModel } from '../../models/lottery.model';
import { BettingOrderHelper } from '../bettingorder/bettingorder.helper';

/*
    开奖页面
    TQQ 2016-12-27
*/
@Component({
  selector: 'page-lottery',
  templateUrl: 'lotteryopen.html',
  providers: [LotteryOpenService, BettingOrderHelper]
})
export class LotteryOpenPage {
  constructor(
    public navCtrl: NavController,
    private lotteryopenService: LotteryOpenService,
    private alert: AlertService,
    private loadding: LoaddingService,
    private auth: AuthService,
    private bettinghelper: BettingOrderHelper,
    private stroage:StorageService) { }

  openlatest: LotteryOpenModel[];
  bricks: any;
  brick: any;

  ionViewDidLoad() {
    this.bricks = this.stroage.read<LotteryModel[]>("lotterys");
    this.getLotteryOpenLatest();
  }


  getMarkSixColor(number) {
      return this.bettinghelper.getLetteryMarkSixColor(number).color;
  }
  //下拉重新加载
  //TQQ 2016-12-27
  doRefresh(refresher) {
    this.getLotteryOpenLatest().then(s => {
      refresher.complete();
    });
  }

  //获取各彩种最新的开奖号码
  //TQQ 2016-12-26
  getLotteryOpenLatest() {
    let load = this.loadding.showLoding("加载中..");
    return this.lotteryopenService.getLotteryOpenLatest().then(s => {
      this.openlatest = s;
      this.loadding.closeLoading(load);
    });
  }

  //跳转到指定彩种开奖页面
  //TQQ 2016-12-27
  goOpenList(obj) {
    if (obj == null) {
      this.alert.showAlert("彩票信息错误");
      return;
    }
    this.navCtrl.push(OpenList, { lotteryCode: obj.LotteryCode, lotteryName: obj.LotteryName });
  }
  goTrend(obj) {
    // if(obj.LotteryCode == '30012' || obj.LotteryCode == '30013' || obj.LotteryCode == '30014' || obj.LotteryCode == '30015' || obj.LotteryCode == '30016' || obj.LotteryCode == '95000'){
    //   this.alert.showAlert("该彩种暂无走势图");
    //   return;
    // }  
    if (obj == null) {
        this.alert.showAlert("彩票信息错误");
        return;
    }
    this.brick = this.bricks.find((item) => {
        return obj.LotteryCode == item.LotteryCode;
    });
    this.navCtrl.push(BrickTrendPage, { brick: this.brick });
  }
}



// WEBPACK FOOTER //
// ./src/pages/lotteryopen/lotteryopen.ts